<template>
  <div>
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <div style="text-align: center;font-size: 20px;">
      <button
        style="width:500px;height:100px;background-color:orange;margin:auto"
        @click="print()"
      >
        طباعة تقرير مديونيات العملاء بالمندوب من الي
        <br />
        {{ $route.query.name }}
      </button>
    </div>
    <div id="printMe" style="display:none">
      <div style="direction:rtl;float:right">
        <p
          style="text-align:center;font-size:22px;font-weight:bold;margin-bottom:15px;text-decoration:underline;"
        >
          تقرير مديونيات العملاء بالمندوب {{ $route.query.name }} من الي
          {{ $route.query.from }} الي
          {{ $route.query.to }}
        </p>
        <div class="row">
          <div class="col-sm-4" style="border-left:1px dotted">
            <div style="float:right;">
              <img
                style="width:100%;height:100px;"
                src="../../../../public/images/pharma_logo.jpg"
                alt="Pharma"
              />
            </div>
          </div>
          <div class="col-sm-4">
            <div style="float:right;font-size:17px;text-align:right">
              <p>
                <span style="font-weight:bold;"> مجموع الافتتاحي : </span>
                <span> {{ total_rasid_efttahi }} </span>
              </p>
              <p>
                <span style="font-weight:bold;">مجموع المبيعات : </span>
                <span> {{ all_of_total }} </span>
              </p>
              <p>
                <span style="font-weight:bold;">مجموع السدادات : </span>
                <span> {{ all_paid }} </span>
              </p>
              <p>
                <span style="font-weight:bold;">مجموع الخصومات : </span>
                <span> {{ all_total_discount }} </span>
              </p>
            </div>
          </div>
          <div class="col-sm-4">
            <div style="float:right;font-size:17px;text-align:right">
              <p>
                <span style="font-weight:bold;"> مجموع المرتجعات : </span>
                <span> {{ all_total_reback }} </span>
              </p>
              <p>
                <span style="font-weight:bold;">نسبة العمولات : </span>
                <span> {{ omola_total }} </span>
              </p>
              <p>
                <span style="font-weight:bold;">مجموع المديونيات : </span>
                <span> {{ all_madionia }} </span>
              </p>
              <p>
                <span style="font-weight:bold;">>عدد الفواتير : </span>
                <span> {{ count_of_count }} </span>
              </p>
            </div>
          </div>
        </div>
        <hr />
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">كود العميل</th>
              <th scope="col">اسم العميل</th>
              <th scope="col">الرصيد الافتتاحي</th>
              <th scope="col">دد فواتير</th>
              <th scope="col">مجموع المبيعات</th>
              <th scope="col">السدادات</th>
              <th scope="col">الخصومات</th>
              <th scope="col">المرتجعات</th>
              <th scope="col">المديونية الحالية</th>
              <th scope="col">عمولة البيع</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas" :key="f.id">
              <th scope="row">{{ f.code }}</th>
              <td>{{ f.name }}</td>
              <td>{{ f.rasid_efttahi }}</td>
              <td>{{ f.count }}</td>
              <td>{{ f.total }}</td>
              <td>{{ f.total_sadad }}</td>
              <td>{{ f.total_discount }}</td>
              <td>{{ f.total_reback }}</td>
              <td>{{ f.madionia }}</td>
              <td>{{ f.omola }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { MandobClientMadioniaReport } from "../../config/apiRoute.js";
import { appUrl } from "../../config/apiConfig.js";
export default {
  data() {
    return {
      loading: true,
      fatworas: [],

      total_rasid_efttahi: "",
      all_of_total: "",
      all_paid: "",
      all_remain: "",
      all_total_discount: "",
      all_total_reback: "",
      omola_total: "",
      all_madionia: "",
      count_of_count: "",
      appUrl: ""
    };
  },
  mounted() {
    this.appUrl = appUrl;
    this.get_data();
  },
  methods: {
    print() {
      this.$htmlToPaper("printMe");
    },
    get_data() {
      var frmData = new FormData();
      frmData.append("mandob_id", this.$route.query.id);
      frmData.append("date_from", this.$route.query.from);
      frmData.append("date_to", this.$route.query.to);
      MandobClientMadioniaReport(frmData).then(response => {
        response.data.myarr.length > 0
          ? (this.fatworas = response.data.myarr)
          : (this.fatworas = []);
        this.total_rasid_efttahi = response.data.total_rasid_efttahi;
        this.all_of_total = response.data.all_of_total;
        this.all_paid = response.data.all_paid;
        this.all_remain = response.data.all_remain;
        this.all_total_discount = response.data.all_total_discount;
        this.all_total_reback = response.data.all_total_reback;
        this.omola_total = response.data.omola_total;
        this.all_madionia = response.data.all_madionia;
        this.count_of_count = response.data.count_of_count;

        this.loading = false;
        setTimeout(() => {
          this.print();
        }, 200);
      });
    }
  }
};
</script>
